export default {
    contactSubTitle: 'Посольство Франции в Российской Федераций',
    contactText1: 'Отдел по науке и технологиям',
    contactText2: 'Отдел стипендий <br />' +
                    '45, ул. Б. Якиманка 15127 Москва',
    contactText3: 'Тел. : +7 (495) 937 15 14, +7 (495) 937 15 09, +7 (495) 937 24 97',
    contactText4: 'Е-Мейл: <br /> <a href="mailto:bgf.moscou-amba@diplomatie.gouv.fr">bgf.moscou-amba@diplomatie.gouv.fr</a>'
}